import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when user is near the bottom of the page
  const toggleVisibility = () => {
    const scrollY = window.scrollY;
    const scrollPosition = scrollY + window.innerHeight;
    const threshold = document.documentElement.scrollHeight - 600;
    // Require the user to have scrolled past the hero before showing
    setIsVisible(scrollY > 600 && scrollPosition >= threshold);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("resize", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("resize", toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-[160px] md:bottom-[176px] right-5 md:right-8 z-[99] flex h-14 w-14 items-center justify-center rounded-full bg-ocean-deep text-white shadow-[0_8px_25px_rgba(15,40,70,0.4)] transition-all duration-300 hover:scale-110 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(15,40,70,0.6)] animate-fade-in focus:outline-none group"
          aria-label="Scroll to top"
        >
          <ChevronUp className="w-6 h-6 transition-transform duration-300 group-hover:-translate-y-1" strokeWidth={2.5} />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
